import { connect } from "react-redux";
import Login from "../../components/Auth/Login";
import { push } from "react-router-redux";
import {
  sendLogin,
  showForgotPassword,
  forgotPassword,
  logout,
  resetPassword,
  setEmail,
  setPassword,
  mountSession,
  getAPIBuildNumber,
} from "../../actions/App";

function mapStateToProps(state) {
  const {
    loginDialog,
    forgotPassword,
    loggedIn,
    email,
    password,
    userId,
    token,
    roleId,
    roleName,
    apiBuildNumber,
    loginErrorMessage,
    tokenExpirationTime,
    clients,
    selected_client,
    loginUserDetail,
    avatar,
  } = state.app;
  return {
    loginDialog,
    forgotPassword,
    email,
    password,
    loggedIn,
    userId,
    roleId,
    roleName,
    clients,
    selected_client,
    token,
    loginUserDetail,
    tokenExpirationTime,
    loginErrorMessage,
    avatar,
    apiBuildNumber,
    location: {
      path: state.routing.location.pathname,
      queryStep: state.routing.location.match
        ? state.routing.location.match.params.step
        : "",
      query: state.routing.location.match
        ? state.routing.location.match.params
        : null,
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    mountSession: (session) => {
      dispatch(mountSession(session));
    },

    handleLoginSubmit: (email, password) => {
      dispatch(sendLogin(email, password));
    },

    handleLogout: () => {
      window.localStorage.removeItem("session");
      window.localStorage.clear();
      dispatch(logout());
    },

    handleForgotPassword: () => {
      dispatch(showForgotPassword());
    },

    handleForgotPasswordSubmit: (email) => {
      dispatch(forgotPassword(email));
    },

    handleResetPassword: (token, email, password) => {
      dispatch(resetPassword(token, email, password));
    },

    setEmail: (email) => {
      dispatch(setEmail(email));
    },

    setPassword: (password) => {
      dispatch(setPassword(password));
    },
    getAPIBuildNumber: () => {
      dispatch(getAPIBuildNumber());
    },
  };
}

const UserLogin = connect(mapStateToProps, mapDispatchToProps)(Login);

export default UserLogin;



// WEBPACK FOOTER //
// ./src/containers/Auth/Login.js